import Glide from '@glidejs/glide';

export default function () {
  const eventsCarousel = document.querySelector('.podcast-carousel--container');

  if (!eventsCarousel) {
    return;
  }

  /**
   * Instantiate the events carousel.
   */
  new Glide('.podcast-carousel--container', {
    type: 'carousel',
    perView: 1,
  }).mount();
}
